import RestrictionCard from "./RestrictionCard";
export default RestrictionCard;
